import { coerceToNonEmpty, isNonEmptyUniformArray } from '../../typeguards/index.js';
import { TagAssignmentStatuses } from '../constants.js';
import { isCommerceTag } from './commerceDataTypes.js';
export function isCommerceSearchResult(subject) {
    const search = coerceToNonEmpty(subject);
    if (search === false || !('vendor' in search && 'results' in search)) {
        return false;
    }
    if (!(search.results instanceof Array)) {
        return false;
    }
    return true;
}
export function isCommerceDiscoverResult(subject) {
    const result = coerceToNonEmpty(subject);
    if (result === false || !result.url) {
        return false;
    }
    // @todo: implement this
    return true;
}
export function isCommerceItemDetailsResult(subject) {
    const result = coerceToNonEmpty(subject);
    if (result === false ||
        !('failedItems' in result &&
            Array.isArray(result.failedItems) &&
            'successItems' in result &&
            Array.isArray(result.successItems))) {
        return false;
    }
    return true;
}
export function isAccountUpdateSiteTagsResponse(subject) {
    const response = coerceToNonEmpty(subject);
    if (response === false ||
        !('siteId' in response &&
            typeof response.siteId === 'string' &&
            'successfulAdditions' in response &&
            typeof response.successfulAdditions === 'number' &&
            'unusedTags' in response &&
            typeof response.unusedTags === 'number' &&
            'assignedTags' in response &&
            typeof response.assignedTags === 'number' &&
            'failedTags' in response &&
            Array.isArray(response.failedTags))) {
        return false;
    }
    return true;
}
export function isCommerceAccountConfigurationResult(subject) {
    const result = coerceToNonEmpty(subject);
    if (result === false ||
        !('siteId' in result && 'vendor' in result && 'linkTags' in result && 'linkWrappers' in result)) {
        return false;
    }
    if (!isNonEmptyUniformArray(result.linkTags, 'string')) {
        return false;
    }
    // if (
    //     result.linkWrappers.Skimlinks !== undefined &&
    //     !isNonEmptyUniformArray(result.linkWrappers.Skimlinks, 'string')
    // ) {
    //     return false;
    // }
    return true;
}
export function isSiteListingResponse(subject) {
    const response = coerceToNonEmpty(subject);
    if (response === false || !('sites' in response) || typeof response.sites !== 'object') {
        return false;
    }
    if (response.sites.every((site) => typeof site === 'object' &&
        typeof site.id === 'string' &&
        typeof site.displayName === 'string')) {
        return true;
    }
    return false;
}
export function isCommerceTagAssignmentResult(subject) {
    return (isCommerceTagSuccessfulAssignmentResult(subject) || isCommerceTagUnsuccessfulAssignmentResult(subject));
}
export function isCommerceTagSuccessfulAssignmentResult(subject) {
    const result = coerceToNonEmpty(subject);
    if (result === false) {
        return false;
    }
    if (result.status === 'Failed' || !TagAssignmentStatuses.includes(result.status)) {
        // Either it's an unsuccessful result or the status isn't correct
        return false;
    }
    return isCommerceTag(result.tag);
}
export function isCommerceTagUnsuccessfulAssignmentResult(subject) {
    const result = coerceToNonEmpty(subject);
    if (result === false) {
        return false;
    }
    return (result.status !== 'Failed' ||
        typeof result.message !== 'string' ||
        (result.tag !== undefined && !isCommerceTag(result.tag)));
}
//# sourceMappingURL=commerceResponseTypes.js.map